import { BudgetType } from "./interface";

const getMethodName: (budgetType: BudgetType) => string = (budgetType: BudgetType) => {
	switch(budgetType){
	case BudgetType.OPERATIONAL_EXPENSES:
		return "QueryBudgetValuesOperationalExpenses";
	case BudgetType.OTHER_EXPENSES:
		return "QueryBudgetValuesOtherExpenses";
	default:
		return "QueryBudgetValuesSalesRevenue";
	}
};

export default getMethodName;
